import { NavLink } from 'react-router-dom';
import {
  InputText,
  ButtonSecondary,
  IconChangeLoClock,
  formatPhone,
  IconLock,
  IconArrowRight,
  ToggleInput,
  IconSelected,
  IconClose,
} from '@ui/src';
import { ClientDetailsTypes } from './types';

import cn from './styles.module.css';

const ClientDetails = ({
  onResetPassword,
  recoveryInProgress,
  clientId,
  changeLogsAvailable,
  client,
  activeLock,
  onViewLocksClick,
  activeStatus,
  onUpdateStatus,
  updateClientInProgress,
  resetPasswordAvailable,
}: ClientDetailsTypes) => (
  <div className={cn.clientDetails}>
    {activeLock && (
      <div className={cn.lockInfo}>
        <div className={cn.lockInfoLeft}>
          <div className={cn.lockInfoIcon}>
            <IconLock />
          </div>
          <div className={cn.lockInfoText}>Authorization is locked</div>
        </div>
        <div className={cn.lockInfoButtonWrapper}>
          <button
            type="button"
            className={cn.lockInfoButton}
            onClick={onViewLocksClick}
          >
            <div className={cn.lockInfoButtonContent}>View locks</div>
            <div className={cn.lockInfoButtonContent}>
              <IconArrowRight width={12} height={12} />
            </div>
          </button>
        </div>
      </div>
    )}
    <div className={cn.totpInfo}>
      {client?.totpEnabled ? (
        <IconSelected />
      ) : (
        <IconClose width={15} height={15} className={cn.disabled} />
      )}
      TOTP-confirmation {client?.totpEnabled ? 'enabled' : 'not enabled'}
    </div>
    <div className={cn.formGroup}>
      <ToggleInput
        name="active"
        checked={Boolean(activeStatus === 'ACTIVE')}
        disabled={updateClientInProgress}
        onChange={(e) => {
          if (e.target.checked) {
            onUpdateStatus('ACTIVE');
          } else {
            onUpdateStatus('DISABLED');
          }
        }}
        title="Active"
      />
    </div>
    <div className={`${cn.formGroup} ${cn.formGroupFlex}`}>
      <InputText
        name="firstName"
        value={client?.profile?.firstName}
        placeholder=""
        title="First Name"
        labelClassName={cn.nameInput}
        disabled
      />
      <InputText
        name="lastName"
        value={client?.profile?.lastName}
        placeholder=""
        title="Last Name"
        labelClassName={cn.nameInput}
        disabled
      />
    </div>
    <div className={cn.formGroup}>
      <InputText
        name="id"
        value={client?.id}
        placeholder=""
        title="Identifier"
        disabled
      />
    </div>
    <div className={cn.formGroup}>
      <InputText
        name="phone"
        value={client?.phone ? formatPhone(client?.phone) : ''}
        placeholder=""
        title="Phone"
        disabled
      />
    </div>
    <div className={`${cn.formGroup} ${cn.moreMargin}`}>
      <InputText
        name="email"
        value={client?.email}
        placeholder=""
        title="Email"
        disabled
      />
    </div>
    {resetPasswordAvailable && (
      <>
        <ButtonSecondary
          className={cn.resetPassword}
          text={recoveryInProgress ? 'Loading...' : 'Reset user password'}
          onClick={onResetPassword}
          bold
        />
        <div className={cn.resetPasswordHint}>
          The current user password will be reset.
        </div>
        {/* <div className={cn.resetPasswordHint}>
          A link to restore the password will be sent to the user.
        </div> */}
      </>
    )}

    {changeLogsAvailable && clientId && (
      <NavLink
        to={`/administration/change-logs?entityType=USER&entityId=${clientId}`}
        className={cn.changeLogLink}
        target="_blank"
      >
        <IconChangeLoClock />
        Change Log
      </NavLink>
    )}
  </div>
);

export default ClientDetails;
